export default {
  // customized mutations
}